export const showCorrectPrice = () => {
  const oneTimePlans = document.querySelectorAll(".meal-plan-one-time");
  const subscriptionPlans = document.querySelectorAll(
    ".meal-plan-subscription",
  );

  oneTimePlans.forEach(function (plan) {
    plan.style.display = "none";
  });

  subscriptionPlans.forEach(function (plan) {
    plan.style.display = "inline-block";
  });
};


/**
 * Return the total count of meal items in the count as apposed to generic cart total - we don't want to include addons here
 *
 * @returns {number}
 */
export const calculateMealCount = (items) => {
  let _count = 0;
  items.map((i) => {
    if (i.product_type == "Meal") _count = _count + i.quantity;
    if (i.product_type == "Repas") _count = _count + i.quantity;
  });
  return _count;
};


/**
 * A useful way for detetcing when elements are added to the DOM via async code
 *
 * @param {string} selector - any valid query selector
 * @returns {*}
 */
export const waitForElm = (selector) => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
};


export const randomString = () => {
  //define a variable consisting alphabets in small and capital letter
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz123456789";

  //specify the length for the new string
  let lenString = 21;
  let randomstring = "";

  //loop to select a new character in each iteration
  for (let i = 0; i < lenString; i++) {
    let rnum = Math.floor(Math.random() * characters.length);
    randomstring += characters.substring(rnum, rnum + 1);
  }

  return randomstring;
};


export const getCookie = (name) => {
  let cookie = {};
  document.cookie.split(";").forEach(function (el) {
    let [k, v] = el.split("=");
    cookie[k.trim()] = v;
  });
  return cookie[name];
};



export const generateBoxID = () => {
  let id = getCookie("bid");
  return id;
};


export const getDayOfWeek = dateString => {
  const date = new Date(dateString);
  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return daysOfWeek[date.getDay()];
}